export default "__VITE_ASSET__T2hAu0eB__"